<template>
  <div class="row">
    <div class="d-flex justify-content-start">
      <a href="#" class="pe-2 collapse-link" @click.prevent="collapseLinkClickHandler()" :aria-label="collapseText" :key="collapseText">
        <vue-feather class="collapse-button" :type="collapseButtonFeatherType"></vue-feather>
        <span class="collapse-text">{{ collapseText }}</span>
      </a>
    </div>
  </div>

</template>

<script>
import {appGlobals} from '@/shared/appGlobals'
import {Collapse} from 'bootstrap'
import {useEventsStore} from "@/store/events"
import VueFeather from 'vue-feather'

export default {
  name: 'ExpandCollapseSessionDescription',

    components: {
        VueFeather,
    },

    created() {
        if (appGlobals.phoneScreenMaxWidthInPixels < window.innerWidth) {
            this.collapseButtonFeatherType = 'chevrons-up'
            this.currentState = 'expanded'
            this.collapseText = 'Collapse all sessions'
        }
    },

    data() {
        return {
            collapseButtonFeatherType: 'chevrons-down',
            currentState: 'collapsed',
            collapseText: 'Expand all sessions',
            eventsStore: useEventsStore(),
        }
  },

  methods: {
    collapseLinkClickHandler() {
      if (this.currentState == 'collapsed') {
        let collapseElementList = [].slice.call(document.querySelectorAll('.collapse.session-description'))
        collapseElementList.map(function (collapseEl) {
          let collapsible = Collapse.getOrCreateInstance(collapseEl)
          collapsible.show()

        })
        this.eventsStore.expandCollapseSessionDescriptionState = '' /*this will for expanded to be broadcast every time*/
        this.eventsStore.expandCollapseSessionDescriptionState = 'expanded'
        this.collapseButtonFeatherType = 'chevrons-up'
        this.collapseText = 'Collapse all sessions'
        this.currentState = 'expanded'
      } else if (this.currentState == 'expanded') {
        let collapseElementList = [].slice.call(document.querySelectorAll('.collapse.session-description'))
        collapseElementList.map(function (collapseEl) {
          let collapsible = Collapse.getOrCreateInstance(collapseEl)
          collapsible.hide()
        })
        this.eventsStore.expandCollapseSessionDescriptionState = ''/*this will for collapse to be broadcast every time*/
        this.eventsStore.expandCollapseSessionDescriptionState = 'collapsed'
        this.collapseButtonFeatherType = 'chevrons-down'
        this.collapseText = 'Expand all sessions'
        this.currentState = 'collapsed'
      } else {
        console.log('Unrecognized expand/collapse state')
      }
    }
  },
}
</script>

<style scoped>
.collapse-button {
    color: var(--phoenix-navbar-vertical-link-color);
    height: 1.5rem;
    margin-top: 1em;
}

.collapse-link {
    text-decoration: none;
}

.collapse-text {
    color: var(--phoenix-navbar-vertical-link-color);
    font-size: smaller;
    position: relative;
    top: -0.5em;
}
</style>